import { render, staticRenderFns } from "./leyouIndex.vue?vue&type=template&id=4ccb4b43"
import script from "./leyouIndex.vue?vue&type=script&lang=js"
export * from "./leyouIndex.vue?vue&type=script&lang=js"
import style0 from "./leyouIndex.vue?vue&type=style&index=0&id=4ccb4b43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports